import { BannerWrap } from 'src/styles/styledcomponent/component/common'
import faq from '../../assets/images/familycare_faq.jpg';

const Faq = (): JSX.Element => {
  
  // 개발기에는 이미지가 존재하지 않습니다.
  return (
    <BannerWrap>
      <img src={faq} alt="FAQ" />
    </BannerWrap>
  )
}
export default Faq
